/* ================= KONNI39 - QUY TAC NGHIEP VU =================
   Nhom trang thai, ten san pham hien thi.
   Tach nguyen ven tu app/KONNI39-xu-ly-don-hang_v4.html.
   Quy tac chi tiet: docs/01-DU-LIEU.md muc 3 va 4.
================================================================ */
import { norm } from './text.js';

/* ---------- nhom trang thai ---------- */
export const GROUPS = {
  MOI: 'Đơn mới',
  CAN_GIAO: 'Cần giao',
  XONG: 'Đã xong',
  HUY: 'Đã hủy',
  KHAC: 'Chưa nhận diện'
};

/* Doi 1 dong duy nhat khi chot quy tac TikTok:
   true  = TikTok "Đã vận chuyển" + substatus "Đã giao" xep vao XONG (giong Shopee)
   false = van xep CAN_GIAO */
export const CONFIG = { tiktokDaGiaoLaXong: true };

/* Khop bang TIEN TO, bo qua hoa thuong, chuoi da NFC.
   Trang thai Shopee co dang cau dai kem ngay -> KHONG so chuoi cung. */
export function statusGroup(channel, raw, sub) {
  var s = norm(raw), b = norm(sub);
  if (!s) return 'KHAC';
  if (channel === 'SHOPEE') {
    if (/^chờ giao hàng/i.test(s)) return 'MOI';
    if (/^đã hủy/i.test(s)) return 'HUY';
    if (/^hoàn thành/i.test(s)) return 'XONG';
    if (/^đã giao/i.test(s)) return 'XONG';
    if (/^người mua xác nhận đã nhận được hàng/i.test(s)) return 'XONG';
    if (/^đang giao/i.test(s)) return 'CAN_GIAO';
    return 'KHAC';
  }
  if (/^cần vận chuyển/i.test(s)) return 'MOI';
  if (/^đã hủy/i.test(s)) return 'HUY';
  if (/^đã hoàn tất/i.test(s)) return 'XONG';
  if (/^đã vận chuyển/i.test(s)) {
    if (CONFIG.tiktokDaGiaoLaXong && /^đã giao/i.test(b)) return 'XONG';
    return 'CAN_GIAO';
  }
  return 'KHAC';
}

/* Tinh lai statusGroup cho toan bo don khi quy tac doi — khong can nap lai Excel */
export function regroup(orders) {
  var changed = 0;
  Object.keys(orders).forEach(function (k) {
    var o = orders[k];
    var g = statusGroup(o.channel, o.statusRaw, o.subStatus);
    if (o.statusGroup !== g) { o.statusGroup = g; changed++; }
  });
  return changed;
}

/* ---------- ten san pham: cat 50 ky tu + ghep phan loai ---------- */
export function shortName(full, maxLen) {
  maxLen = maxLen || 50;
  var s = norm(full);
  if (s.length <= maxLen) return s;
  var cut = s.slice(0, maxLen);
  var i = cut.lastIndexOf(' ');
  if (i > 25) cut = cut.slice(0, i);
  return cut.replace(/[\s,\-–—/]+$/, '') + '…';
}
export function displayName(full, variation) {
  var v = norm(variation);
  var s = shortName(full);
  return v ? s + ' — ' + v : s;
}

/* ---------- hang van chuyen: gop theo hang, bo tien to Nhanh-/Hoa Toc-/Tiet Kiem- ----------
   Tach rieng SPX Express va SPX Instant (shipper den lay khac dot).
   Ten that gap trong du lieu: docs/02-CHUC-NANG.md muc Tab 3. */
export const CARRIER_UNKNOWN = '(chưa gán hãng)';
export function carrierGroup(name) {
  var s = norm(name);
  s = s.replace(/^(nhanh|hỏa tốc|tiết kiệm|tủ nhận hàng)\s*-\s*/i, '');
  if (!s || /^\(không rõ\)$/i.test(s) || /^(nhanh|hỏa tốc|tiết kiệm)$/i.test(s)) return CARRIER_UNKNOWN;
  var rules = [
    [/spx\s*instant/i, 'SPX Instant'],
    [/spx/i, 'SPX Express'],
    [/giao hàng nhanh|\bghn\b/i, 'GHN'],
    [/j&t/i, 'J&T'],
    [/green\s*sm/i, 'Green SM'],
    [/bedelivery/i, 'beDelivery'],
    [/grab/i, 'GrabExpress'],
    [/vnpost|vietnam post/i, 'VNPost'],
    [/viettel/i, 'Viettel Post'],
    [/ghtk|giao hàng tiết kiệm/i, 'GHTK'],
    [/ninja/i, 'Ninja Van'],
    [/ahamove/i, 'Ahamove'],
    [/\bbest\b/i, 'BEST']
  ];
  for (var i = 0; i < rules.length; i++) if (rules[i][0].test(s)) return rules[i][1];
  return s;
}
